define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 视频播放模式。
     *
     * @exports EnumVideoPlayStatus
     * 
     * @see VideoFusion#playStatus
     */
    var EnumVideoPlayStatus = {
        /**
         * 播放。
         * @type {Number}
         * @constant
         */
        PLAY: 1,

        /**
         * 暂停。
         * @type {Number}
         * @constant
         */
        PAUSE: 2,

        // /**
        //  * 停止。
        //  * @type {Number}
        //  * @constant
        //  */
        // STOP: 0
    }
    freezeObject(EnumVideoPlayStatus)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumVideoPlayStatus) {
            if (EnumVideoPlayStatus.hasOwnProperty(key) && EnumVideoPlayStatus[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        PLAY: 1,
        PAUSE: 2,
        // STOP: 0,
        getName: getName
    }
})